import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Modal, ListGroup, ListGroupItem, FormControl, Button } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import _ from 'lodash';

import { gettext } from '../../i18n/service';
import { parseExpectedPickUpTime } from '../../businessLogic/expectedPickUpTimeParser.js';
import * as actions from '../../actions/dashboardPageActions';
import './DriverListModal.scss';

class DriverListModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchFilter: '',
      driverTypeFilter: '',
      isShow: false,
      showModal: true,
      drivers: [],
      selectedDriver: {}
    };

    this.clickedDriver = undefined;

    this.close = this.close.bind(this);
    this.renderDrivers = this.renderDrivers.bind(this);
    this.orderToDriver = this.orderToDriver.bind(this);
    // this.showToggle = this.showToggle.bind(this);
  }

  componentWillMount() {
    let temp = [];
    let driverIds = [];
    const { drivers, order } = this.props;
    drivers.map(driver => {
      if(driver.driverStatus == 'active') {
        temp.push(driver);
        driverIds.push(driver.id);
      }
    });

    if(order.items[0].hasOwnProperty('pickUpPoint') && order.items[0].pickUpPoint.hasOwnProperty('gpsLocation')) {
      this.props.actions.getDriversDistance(order.items[0].pickUpPoint.gpsLocation, driverIds);
    }
    
    this.setState({ drivers: temp });
    this.setState({ driversToShowInList: temp });
  }

  getDriverOrders(driverId) {
    return _.filter(this.props.originalOrders, (order) => {
      return order.driverId === driverId && order.orderStatus !== 'canceled'
        && order.orderStatus !== 'returned' && order.orderStatus !== 'delivered';
    });
  }

  close() {
    this.props.close();
  }

  clickOnDriver(e, driver) {
    e.preventDefault();   
    this.setState({ selectedDriver: driver });
    this.forceUpdate();
  }

  showToggle(e, driver) {
    // e.preventDefault();
    e.stopPropagation();
    if(typeof this.clickedDriver == 'undefined') {
      this.clickedDriver = driver;
      this.setState({ isShow: true });
    } else {
      if(driver.id != this.clickedDriver.id) {
        this.clickedDriver = driver;
        this.setState({ isShow: true });
      } else {
        this.clickedDriver = driver;
        this.setState({ isShow: !this.state.isShow });
      }
    }
  }

  searchInDrivers(val) {
    const { drivers } = this.state;
    this.setState({ searchFilter: val });
    const driversToShowInList = _.filter(drivers, (driver) => {
      return (driver.firstName.toUpperCase().indexOf(val.toUpperCase()) != -1);

    }); 
    this.setState({ driversToShowInList: driversToShowInList });
  }

  handleDriverShowType(val) {
    const { drivers } = this.state;
    const { orderDriversDistance } = this.props;
    this.setState({driverTypeFilter: val});    
    let driversToShowInList = _.uniqBy(drivers, 'id');

    if (val === "fulltime") {
      driversToShowInList = _.filter(driversToShowInList, (driver) => {
        return driver.isFullTime;
      });
    }

    if (val === "freelancer") {
      driversToShowInList = _.filter(driversToShowInList, (driver) => {
        return !driver.isFullTime;
      });
    }

    this.setState({ driversToShowInList: driversToShowInList });

    if (val === "near") {
      let temp = [];
      const sortedDriversDistance = _.sortBy(orderDriversDistance, [function(o) { return o.distanceToOrder; }]);
      sortedDriversDistance.map(driver => {
        const sortedDriver = _.find(driversToShowInList, { id: driver.driverId });
        temp.push(sortedDriver);
      });
      this.setState({ driversToShowInList: temp });
    }
  }

  orderToDriver() {
    const { order } = this.props;
    const { selectedDriver } = this.state;
    this.props.actions.assignOnDriver(selectedDriver.id, order.id, localStorage.getItem('userType'));
  }

  renderPickupRow(order) {
    return _.map(order.items, (item) => {
      const endTime = moment(order.expectedPickUpTime.endTime).zone('+0300').format('HH:mm');
      return (
        <Row className="order_details_row media bottom-border order-list-item" key={item.id}>
          <div className="media-left">
          {
            order.orderStatus === 'assigned' || order.orderStatus === 'waitingForPickup' ?
            <img className="pin-icon media-object" src={`./${order.orderStatus.toLowerCase()}.svg`} />
            : ''
          }
          </div>
          <div className="media-body">
          {
            order.orderStatus === 'assigned' || order.orderStatus === 'waitingForPickup' ?
            <div className="address">{item ? ' ' + item.pickUpPoint.address : ''}
              <p>{parseExpectedPickUpTime(order.expectedPickUpTime)}</p>
            </div>
             :''
          }
          </div>
        </Row>
      );
    });
  }

  renderDrivers(driversToShowInList) { 
    const { orderDriversDistance } = this.props;
    return _.map(driversToShowInList, (driver, i) => {
      const driverVehicle = _.find(this.props.vehicles, { size: + driver.vehicleType }) || {};
      let maxDeliveryTime = 0;
      const driverOrderInfo = _.find(orderDriversDistance, { driverId: driver.id }) || {};
      const driverOrders = _.map(this.getDriverOrders(driver.id), (order) => {
        const recipient = _.find(this.props.recipients, { id: order.recipientId });
        const deliveryTime  = moment(order.deliveryTime).zone('+0300').format('HH:mm');
        if (maxDeliveryTime < order.deliveryTime) {
          maxDeliveryTime = order.deliveryTime;
        }
        if(this.state.isShow && this.clickedDriver.id == driver.id)
          return (
            <div
              className="driver_order"
              key={order.id}>
              {/*<Row className="order_details_row order-list-item top-border order-info">
                <div className="media">
                  <div className="media-body">
                  </div>
                  <div className="media-right">
                  {
                    <Link onClick={() => this.props.renderModalForDetails(order, true)}>
                      <img src="./side_menu.svg" />
                    </Link>
                  }
                  </div>
                </div>
              </Row>*/}
              {this.renderPickupRow(order)}
              <Row className="order_details_row media bottom-border order-list-item">
                <div className="media-left">
                  <img className="pin-icon" src={`./${order.orderStatus.toLowerCase()}.svg`} />
                </div>
                <div className="media-body">
                  <p className="address">{recipient ? ' ' + recipient.deliveryPoint : ''}
                   <p>{deliveryTime}</p>
                  </p>
                </div>
              </Row>
            </div>
          );
      });

      let className = 'display_none';
      if (this.clickedDriver && (driver.id === this.clickedDriver.id)) {
        className = 'driver_orders';
      }

      // const icon = className=='driver_orders' ? 'chevron-down' : 'menu-right';
      let icon = 'menu-right';
      if(this.state.isShow && className=='driver_orders') {
        icon = 'chevron-down';
      } else {
        icon = 'menu-right';
      }
      const maxDeliveryTimeLabel = moment(maxDeliveryTime).zone('+0300').format('HH:mm');

      const jobCount = _.filter(this.getDriverOrders(driver.id), function(obj) {
          return obj.orderStatus !== 'new';
      }).length;

      return (
        <div key={i}>
          <ListGroupItem>
            <div className="driver_info">
              <div
                className={this.state.selectedDriver.id && this.state.selectedDriver.id == driver.id ? "driver_order_selected driver-detail media" : "driver-detail media"}
                onClick={(e) => this.clickOnDriver(e, driver)}>
                <div className="media-left">
                  <span className={"glyphicon glyphicon-" + icon} onClick={(e) => this.showToggle(e, driver)} />
                </div>
                <div className="media-body">
                  <div className="driver-avatar">
                    <img src="./driver-no-avatar.svg" width="40"/>
                  </div>
                  <div className="driver-name-job">
                    <p className="driver-name">
                      {driver.firstName}                      
                    </p>
                    <div className="driver-order-distance">
                      {
                        driverOrderInfo.distanceToOrder &&  <span>{ Math.round(driverOrderInfo.distanceToOrder / 1000) }km</span>
                      }
                      { 
                        driverOrderInfo.timeToOrder && <span>{ Math.round(driverOrderInfo.timeToOrder / 60) }min</span>
                      }
                    </div>
                    
                    <p className="driver-jobs">
                      {jobCount > 0 ? (jobCount + ' ' + gettext('Jobs') + ', till ' + maxDeliveryTimeLabel) : gettext('DRIVER-IS-FREE')}
                    </p>
                  </div>
                </div>
                <div className={driver.driverStatus === 'active' ? 'active_driver media-right' : 'inactive_driver media-right'}>
                  <img alt={driverVehicle.type} src={driverVehicle.icon} height="20" />
                </div>
              </div>
              <div className={className}>
                {driverOrders.length > 0 ? driverOrders : gettext('DRIVER-HAVENT-ORDERS')}
              </div>
            </div>
          </ListGroupItem>
        </div>
      );      
    });
  }

  render() {
    const { drivers, selectedDriver, driversToShowInList } = this.state;   
   
    if(drivers.length > 0) {
      return (
        <Modal className="modal-center assigned-modal" show={this.props.showModal}
          onHide={this.close} bsSize="sm">
          <Modal.Header closeButton>
            <p>{gettext('MODAL.SELECT-DRIVER-TO-ORDER')}</p>
          </Modal.Header>
          <Modal.Body>
            <div className="search_input">
              <FormControl className="textBox" placeholder={gettext('SEARCH')} type="text" onChange={(e) => this.searchInDrivers(e.target.value)} />
              <FormControl
                componentClass="select"
                className="driver_select_show"
                onChange={(e) => this.handleDriverShowType(e.target.value)}>
                <option value="all">  {gettext('ALL')}  </option>
                <option value="near"> {gettext('NEAR-DRIVER')} </option>
                <option value="fulltime"> {gettext('FULL-TIME-DRIVER')} </option>
                <option value="freelancer"> {gettext('FREELANCER-DRIVER')} </option>
              </FormControl>
            </div>
            <Scrollbars className="rightside-list" style={{ height: '20em' }} renderView={props => <div {...props} className="view"/>}>
              <div className="scrolling_list">
                <ListGroup>
                  {this.renderDrivers(driversToShowInList)}
                </ListGroup>
              </div>
            </Scrollbars>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.orderToDriver} disabled={!selectedDriver.id}>
              {gettext('MODAL.ASSIGN')}
            </Button>
            <Button  onClick={this.close}>{gettext('MODAL.CANCEL')}</Button>
          </Modal.Footer>
        </Modal>
      );
    } else {
      return null;
    }    
  }
}

function mapStateToProps(state) {
  return {
    orderDriversDistance: state.dashboardPageReducer.orderDriversDistance
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverListModal);


// WEBPACK FOOTER //
// ./src/components/modals/DriverListModal.js